import NextImage from 'next/image'

import { Heading } from 'components/heading'
import { Markdown } from 'components/markdown'

import house from '../images/house-img.png'
import classes from './right-section.module.css'
import { MAIN_TEXT } from './consts'
import { SubscribeForm } from './form'

export const RightSection = () => {
  return (
    <div className={classes.rightSectionWrapper}>
      <div className={classes.topSection}>
        <NextImage
          src={house.src}
          alt="house img"
          width={230}
          height={170}
          className={classes.houseImg}
        />
        <div className={classes.headingTextWrapper}>
          <Heading theme="h2" className={classes.title}>
            Want an edge in selling?
          </Heading>
          <p className={classes.subtitle}>
            Sell faster and at your price! Offer price protection in your listing at NO COST.
          </p>
        </div>
      </div>
      <Markdown className={classes.mainText}>{MAIN_TEXT}</Markdown>
      <SubscribeForm />
    </div>
  )
}
